// removed by extract-text-webpack-plugin
module.exports = {"contactCard":"src-components-contactCard----contactCard-module---contactCard---1TYXY","imageContainer":"src-components-contactCard----contactCard-module---imageContainer---1QNFB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contactCard/contactCard.module.scss
// module id = 283
// module chunks = 69949351783210 95715928098905